import { batch } from 'editor/src/store/batchedSubscribeEnhancer';
import type { ThunkDispatch } from 'editor/src/store/hooks';
import { RootState } from 'editor/src/store/index';

import { InboundPostMessage } from 'editor/src/util/postMessages/messages';

import { updateImageAction } from '../../gallery/slice';

import updateMediaElementByUuidOperation from './updateMediaElementByUuidOperation';

const setQuantizedAssetOperation =
  (
    imageData: InboundPostMessage['design.setQuantizedAsset'] & {
      assetId?: string;
    },
  ) =>
  (dispatch: ThunkDispatch, getState: () => RootState) => {
    // Handle skip digitization flag
    if (imageData.skipDigitization) {
      batch(() => {
        const state = getState();
        const imageId = imageData.assetId ?? imageData.file.id;

        // Update gallery image with URL but NO quantized metadata to prevent digitization
        const imageUrl = imageData.url || imageData.thumbnailUrl;
        dispatch(
          updateImageAction({
            id: imageId,
            url: imageUrl, // Set the display URL
            quantizedUrl: imageUrl, // Set same URL so export logic finds it for embroidery spreads
            // Deliberately NOT setting quantizedColors to keep isImageQuantized false
          }),
        );

        // Find all image elements using this imageId and clear their digitizing state
        state.design.designData?.spreads.forEach((spread) => {
          spread.pages[0].groups.media?.forEach((element) => {
            if (element.type === 'image' && element.imageId === imageId && element.digitizing) {
              dispatch(
                updateMediaElementByUuidOperation(element.uuid, {
                  digitizing: undefined,
                  stitch_count: 0, // Mark as complete with valid count
                  // Remove direct URL setting - let it derive from gallery image
                }),
              );
            }
          });
        });
      });
      return; // Skip normal digitization flow
    }

    // Normal quantization processing
    dispatch(
      updateImageAction({
        id: imageData.assetId ?? imageData.file.id,
        quantizedUrl: imageData.quantizedUrl,
        quantizedColors: imageData.file.quantizedColors,
      }),
    );
  };

export default setQuantizedAssetOperation;
